// extracted by mini-css-extract-plugin
export default {"zoomModal":"c2-z","image":"d2-z","button":"e2-z","isOverlayShown":"f2-z"};